/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import DeviceAttributeCondition, {
  isDeviceExistsCondition,
  SpecialDeviceAttributes,
} from 'cio/app-models/conditions/device-attribute';
import { isNone } from '@ember/utils';

interface OperatorArgs {
  condition: DeviceAttributeCondition;
  disabled: boolean;
  operators: { value: string; label: string }[];
  selectedOperator?: any;
  onOperatorSelect: (operator: string) => unknown;
}
export default class Operator extends Component<OperatorArgs> {
  @computed('args.condition.name')
  get isDeviceExistsCondition() {
    return isDeviceExistsCondition(this.args.condition.name);
  }

  @computed('args.condition.name')
  get isLastStatusCondition() {
    return this.args.condition.name === SpecialDeviceAttributes._last_status;
  }

  @computed('args.{condition.name,selectedOperator}')
  get selectedOperator() {
    return this.args.selectedOperator ?? this.resolveSelectedOperator;
  }

  @computed('args.condition.operator')
  get resolveSelectedOperator() {
    let { condition } = this.args;
    let { operator } = condition;
    if (this.isLastStatusCondition && operator.endsWith('exists')) {
      // exists = is not unused, !exists = is unused
      operator = operator.charAt(0) === '!' ? 'eq' : '!eq';
    }
    return operator;
  }

  @action
  onOperatorSelect(newOperator: string) {
    let { onOperatorSelect } = this.args;
    if (isNone(onOperatorSelect)) {
      let operator = newOperator;
      if (this.isLastStatusCondition && this.args.condition.operator.endsWith('exists')) {
        // handles from 'is unused' to 'is not unused' and vice versa
        operator = newOperator === 'eq' ? '!exists' : 'exists';
      }
      this.args.condition.set('operator', operator);
    } else {
      onOperatorSelect(newOperator);
    }
  }
}
